import { api } from '@/services';
import { ApiResponse } from '@/types';
import { isCurrentDay } from '@/utils';
import { PROFILES_API_ENDPOINTS } from '@/constants';

import { IFaceIdProfileUpdate } from '@/features/face-id-profiles/interfaces';
import { ProfileType } from '@/features/face-id-profiles/enums';

const FaceIdProfileUpdateService = {
  UpdateFaceIdProfile: async (
    profile: IFaceIdProfileUpdate,
  ): Promise<ApiResponse<IFaceIdProfileUpdate>> => {
    if (profile.profileType == ProfileType.Guest) {
      if (isCurrentDay(profile.guestValidFrom)) {
        profile.guestValidFrom = new Date();
      }
    }
    const response = await api.patch(
      PROFILES_API_ENDPOINTS.PROFILES_ID.replace(':profileId', profile.profileId),
      profile,
    );
    return response.data;
  },
};

export default FaceIdProfileUpdateService;
